var _a;
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./externalAction.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["PerformExternalAction"] = "PERFORM_EXTERNAL_ACTION";
})(EActionCustom || (EActionCustom = {}));
var generatePerformExternalActions = function () { return ({
    performExternalActionStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PerformExternalAction,
        state: EActionState.Start,
    }),
    performExternalActionSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PerformExternalAction,
        state: EActionState.Success,
    }),
    performExternalActionFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PerformExternalAction,
        state: EActionState.Fail,
    }),
}); };
export var performExternalActionStart = (_a = generatePerformExternalActions(), _a.performExternalActionStart), performExternalActionSucceeded = _a.performExternalActionSucceeded, performExternalActionFailed = _a.performExternalActionFailed;
